import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import documentFiltersSignal, {
	setDocumentFilters,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/Signals/documentFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

export type DocumentTypeOption = {
	readonly id: number;
	readonly label: string;
};

type Props = {
	readonly options: readonly DocumentTypeOption[];
	readonly loading: boolean;
};

const DocumentTypeFilter: React.FC<Props> = ({ options, loading }) => {
	const currentFilters = useSignalValue(documentFiltersSignal);

	const handleChange = React.useCallback((documentTypeId: number | null) => {
		setDocumentFilters(documentFiltersSignal.peek().setDocumentTypeId(documentTypeId));
	}, []);

	return (
		<Dropdown<number>
			name="documentType"
			label="Type de document"
			isLabelHidden
			options={options}
			optionLabel="label"
			optionValue="id"
			value={currentFilters.documentTypeId}
			onChange={handleChange}
			placeholder="Tous les types"
			showClear
			loading={loading}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default DocumentTypeFilter;
